<script lang="ts">
  import '../../../app.postcss'
  import * as Accordion from '$lib/components/shadcn/accordion/index'
  import ArrowSvg from './SVGs/ArrowSVG.svelte'

  let { title, collapseContent }: { title: string; collapseContent: string } = $props()
</script>

<Accordion.Item value={title}>
  <Accordion.Trigger class="faq-trigger cursor-pointer items-baseline rounded-none px-4 py-6">
    <span class="font-graphik text-xl font-normal">{title}</span>

    <ArrowSvg
      svgStyles="faq-arrow rotate-[135deg] transition-transform duration-300 ease-in-out"
      fillStyles="white"
    />
  </Accordion.Trigger>

  <Accordion.Content class="px-4">
    <p class="max-w-[900px] font-graphik">{collapseContent}</p>
  </Accordion.Content>
</Accordion.Item>

<style>
  :global(.faq-trigger[aria-expanded='true'] .faq-arrow) {
    transform: rotate(45deg);
  }
</style>
